export const defaultLocale = 'zh';

export const locales = ['zh', 'en'] as const;

export type Locale = typeof locales[number];

export type Translation = Record<Locale, string>;